import { render, staticRenderFns } from "./BasicPageTitle.vue?vue&type=template&id=48f74460&scoped=true&"
import script from "./BasicPageTitle.vue?vue&type=script&lang=js&"
export * from "./BasicPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./BasicPageTitle.vue?vue&type=style&index=0&id=48f74460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f74460",
  null
  
)

export default component.exports